import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 8,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.gray[100],
    }),
    bar: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
    }),
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme }) => ({
        '& .MuiLinearProgress-bar': {
          background: `linear-gradient(90deg, ${theme.palette.green[400]}, ${theme.palette.green[500]})`,
        },
      }),
    },
    {
      props: { color: 'warning' },
      style: {
        '& .MuiLinearProgress-bar': {
          background: `linear-gradient(90deg, ${colors.warning[400]}, ${colors.warning[600]})`,
        },
      },
    },
    {
      props: { color: 'error' },
      style: ({ theme }) => ({
        '& .MuiLinearProgress-bar': {
          background: `linear-gradient(90deg, ${theme.palette.red[400]}, ${theme.palette.red[500]})`,
        },
      }),
    },
  ],
};
